import { format } from "d3-format";
import { UNIT_TYPES, MISSING_VALUE } from "./consts.js";

/** @typedef {import("./types.d.ts").UnitType} UnitType */

/** @type {Record<UnitType, string>} */
const FORMATS = {
  [UNIT_TYPES.DOLLARS]: "$,.3r",
  [UNIT_TYPES.CREDIT_SCORE]: ",.0~f",
  [UNIT_TYPES.PERCENT]: ".3p",
  [UNIT_TYPES.RATE_CHANGE]: ".1%"
};

/** @type {Record<UnitType, string>} */
const AXIS_FORMATS = {
  [UNIT_TYPES.DOLLARS]: "$.2s",
  [UNIT_TYPES.CREDIT_SCORE]: ",.0f",
  [UNIT_TYPES.PERCENT]: ".0%"
};

/**
 * @param {number} value
 * @param {UnitType} unitType
 * @returns {string}
 */
export function formatValue(value, unitType) {
  if (value === null || value === undefined || isNaN(value)) {
    return MISSING_VALUE;
  }
  const fmt = format(FORMATS[unitType] || ",.2f");
  return fmt(value);
}

/**
 * @param {number} value
 * @param {UnitType} unitType
 * @returns {string}
 */
export function formatShortValue(value, unitType) {
  const fmt = format(AXIS_FORMATS[unitType] || ",.2f");
  return fmt(value);
}

/**
 * @param {string} inputText
 * @returns {string}
 */
export function sentenceCase(inputText) {
  if (!inputText) return "";
  return inputText.charAt(0).toUpperCase() + inputText.slice(1);
}
